<div class="db-loading-bar db-loading-bar_state_{{state}}" [ngStyle]="{height: height + 'px'}" [ngClass]="{'db-loading-bar_loading': loading, 'db-loading-bar_simulation': simulation}">
  <div class="db-loading-bar__bg"></div>
  <div class="db-loading-bar__bar" [ngStyle]="{width: simulation ? '' : progressPercent + '%'}"></div>
</div>
